import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{
      background: "var(--bg2)",
      borderTop: "1px solid var(--border)",
      padding: "32px 24px",
      marginTop: 60,
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
        <div>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 18 }}>
            Ariyom Tech<span style={{ color: "var(--accent)" }}> Solutions</span>
          </span>
          <p style={{ color: "var(--muted)", fontSize: 13, marginTop: 4 }}>
            Building apps that solve real problems.
          </p>
        </div>
        <div style={{ display: "flex", gap: 24, fontSize: 14 }}>
          <Link to="/" style={{ color: "var(--muted)", textDecoration: "none" }}>Home</Link>
          <Link to="/projects" style={{ color: "var(--muted)", textDecoration: "none" }}>Projects</Link>
          <Link to="/about" style={{ color: "var(--muted)", textDecoration: "none" }}>About</Link>
          <Link to="/contact" style={{ color: "var(--muted)", textDecoration: "none" }}>Contact</Link>
        </div>
        <p style={{ color: "var(--muted)", fontSize: 13 }}>
          � {new Date().getFullYear()} Ariyom Tech Solutions
        </p>
      </div>
    </footer>
  );
}
